// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"FW-z","sponsoredTooltipWrapper":"GW-z","sponsoredTooltip":"HW-z","newCard":"IW-z"};